import axios from './http';
import { UserDto } from 'ts-types/api.types';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/current-user`;

export const retrieveAccessToken = (username: string, password: string, verificationCode?: string) => {
  return axios({
    url: `${baseUrl}/auth`,
    method: 'post',
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    data: {
      username: username,
      password: password,
      verificationCode: verificationCode || ""
    }
  });
};

export const getCurrentUser = (): Promise<UserDto> => {
  return axios.get(apiUri).then(response => response.data);
};
